import { getCustomCountries } from "@bevco/Services/CommonService";
import { ApiHandler, createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { CountryModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = ApiParameter & HasOnSuccess<CountryModel[]>;

type Props = {
    apiResult: CountryModel[];
    apiParameter: ApiParameter;
};

type HandlerType = Handler<Parameter, Props>;

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getCustomCountries();
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404)) {
            props.dispatch({
                type: "Custom/Countries/FailedToCountries",
                countries: [],
                message: "Failed to load countries",
            } as any);
            return false;
        }
        throw error;
    }
};

export const DispatchCompleteCustomCountries: HandlerType = props => {
    props.dispatch({
        type: "Custom/Countries/SetCountries",
        countries: props.apiResult,
    } as any);
};

export const chain = [RequestDataFromApi, DispatchCompleteCustomCountries];

const loadCustomCountries = createHandlerChainRunner(chain, "LoadCustomCountries");
export default loadCustomCountries;
